module.exports = __webpack_public_path__ + "static/media/botas.0cf31f42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/botas.jpg
// module id = 1289
// module chunks = 0